import { grey } from "@mui/material/colors";

const styles = {
  card: {
    border: `1px solid ${grey[300]}`,
    width: { xs: "100%", sm: 400 },
    backgroundColor: "white",
    p: 3,
    borderRadius: 3,
    position: "relative",
    boxShadow: 0,
    cursor: "pointer",
    "&:hover": {
      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 8px",
    },
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
};

export default styles;
